var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "LessonEntityDetails__Component" },
    [
      _c("FieldInlineText", {
        attrs: { label: "שם המקבץ" },
        on: { onChange: _vm.onChange },
        model: {
          value: _vm.model.name,
          callback: function ($$v) {
            _vm.$set(_vm.model, "name", $$v)
          },
          expression: "model.name",
        },
      }),
      _c("FieldInlineText", {
        attrs: { type: "number", label: "סדר" },
        on: { onChange: _vm.onChange },
        model: {
          value: _vm.model.sortOrder,
          callback: function ($$v) {
            _vm.$set(_vm.model, "sortOrder", $$v)
          },
          expression: "model.sortOrder",
        },
      }),
      _c("FieldInlineSelect", {
        attrs: {
          label: "קטגוריה",
          filterable: true,
          clearable: true,
          optionsAsync: _vm.getCategories,
        },
        on: { onChange: _vm.onChange },
        model: {
          value: _vm.model.exerciseCategoryId,
          callback: function ($$v) {
            _vm.$set(_vm.model, "exerciseCategoryId", $$v)
          },
          expression: "model.exerciseCategoryId",
        },
      }),
      _c("FieldInlineSelect", {
        attrs: {
          label: "חוק",
          filterable: true,
          clearable: true,
          optionsAsync: _vm.getLaws,
        },
        on: { onChange: _vm.onChange },
        model: {
          value: _vm.model.lawId,
          callback: function ($$v) {
            _vm.$set(_vm.model, "lawId", $$v)
          },
          expression: "model.lawId",
        },
      }),
      _c("FieldInlineSelect", {
        attrs: {
          label: "תקצירי פסיקה",
          filterable: true,
          clearable: true,
          optionsAsync: _vm.getVerdictSummaries,
        },
        on: { onChange: _vm.onChange },
        model: {
          value: _vm.model.verdictSummaryId,
          callback: function ($$v) {
            _vm.$set(_vm.model, "verdictSummaryId", $$v)
          },
          expression: "model.verdictSummaryId",
        },
      }),
      _c(
        "div",
        { staticClass: "checkbox-container" },
        [
          _c(
            "b-switch",
            {
              staticClass: "ltr",
              on: { input: _vm.onChange },
              model: {
                value: _vm.model.status,
                callback: function ($$v) {
                  _vm.$set(_vm.model, "status", $$v)
                },
                expression: "model.status",
              },
            },
            [_vm._v(_vm._s(_vm.model.status ? "פעיל" : "לא פעיל"))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }